// removed by extract-text-webpack-plugin
module.exports = {"OrderItem":"wmf-3ASfqq9k","header":"wmf-qu1Tq_VR","orderCode":"wmf-2983Pta4","left":"wmf-3MlVM7DV","tips":"wmf-1wu4dKkd","contents":"wmf-g_BV2BG0","imgWrap":"wmf-1xvbmUDM","detail":"wmf-2ZMIcSUO","top":"wmf-2G4NaQoe"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/udeskSide/components/OrderItem.module.less
// module id = 952
// module chunks = 0